import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/sealing/inspection/main`,
    name: 'SEALING_INSPECTION_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
